import { CheckCircle2, Loader2, Clock, AlertTriangle, XCircle } from "lucide-react";
import { motion } from "@/lib/motion";

const VARIANTS = {
  success: {
    Icon:   CheckCircle2,
    label:  "Completed",
    color:  "#10B981",
    bg:     "rgba(16,185,129,0.08)",
    border: "rgba(16,185,129,0.22)",
    spin:   false,
  },
  processing: {
    Icon:   Loader2,
    label:  "Processing",
    color:  "#06B6D4",
    bg:     "rgba(6,182,212,0.08)",
    border: "rgba(6,182,212,0.22)",
    spin:   true,
  },
  pending: {
    Icon:   Clock,
    label:  "Pending",
    color:  "#F59E0B",
    bg:     "rgba(245,158,11,0.08)",
    border: "rgba(245,158,11,0.22)",
    spin:   false,
  },
  warning: {
    Icon:   AlertTriangle,
    label:  "Attention",
    color:  "#F59E0B",
    bg:     "rgba(245,158,11,0.08)",
    border: "rgba(245,158,11,0.22)",
    spin:   false,
  },
  failure: {
    Icon:   XCircle,
    label:  "Failed",
    color:  "#EF4444",
    bg:     "rgba(239,68,68,0.08)",
    border: "rgba(239,68,68,0.22)",
    spin:   false,
  },
};

export default function FCSBadge({ variant = "success", label, size = "sm" }) {
  const v    = VARIANTS[variant] || VARIANTS.success;
  const text = label || v.label;
  const iconSize = size === "sm" ? 10 : 11;

  return (
    <motion.span
      initial={{ opacity: 0, scale: 0.88 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.22, ease: [0.16, 1, 0.3, 1] }}
      role="status"
      aria-label={`Status: ${text}`}
      className="inline-flex items-center gap-1 font-bold uppercase rounded-full"
      style={{
        fontSize:       size === "sm" ? "10px" : "11px",
        letterSpacing:  "0.10em",
        padding:        size === "sm" ? "2px 7px" : "3px 9px",
        background:     v.bg,
        border:         `1px solid ${v.border}`,
        color:          v.color,
      }}
    >
      <v.Icon
        size={iconSize}
        strokeWidth={2.2}
        className={v.spin ? "animate-spin" : ""}
      />
      {text}
    </motion.span>
  );
}
